import * as React from 'react';

import { Alert, AlertAction, AlertDescription, AlertTitle } from './components/ui/alert.js';
import { cn } from './lib/utils.js';

/** `warning`, `info` and `success` are ours -- the vendor ships only `default` and `destructive`. */
export type DimeAlertVariant = 'default' | 'destructive' | 'warning' | 'info' | 'success';

type DimeAlertProps = Readonly<
  Omit<React.ComponentProps<typeof Alert>, 'variant'> & { variant?: DimeAlertVariant }
>;

export function DimeAlert({ variant = 'default', className, ...props }: DimeAlertProps) {
  return (
    <Alert
      variant={variant === 'destructive' ? 'destructive' : 'default'}
      className={cn(
        variant === 'warning' &&
          'border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-800 dark:bg-amber-950/30 dark:text-amber-300',
        variant === 'info' &&
          'border-sky-200 bg-sky-50/60 text-sky-800 dark:border-sky-900 dark:bg-sky-950/30 dark:text-sky-300',
        variant === 'success' &&
          'border-emerald-200 bg-emerald-50 text-emerald-900 dark:border-emerald-900 dark:bg-emerald-950 dark:text-emerald-100',
        className,
      )}
      {...props}
    />
  );
}

export function DimeAlertTitle({ ...props }: Readonly<React.ComponentProps<typeof AlertTitle>>) {
  return <AlertTitle {...props} />;
}

export function DimeAlertDescription({
  ...props
}: Readonly<React.ComponentProps<typeof AlertDescription>>) {
  return <AlertDescription {...props} />;
}

export function DimeAlertAction({ ...props }: Readonly<React.ComponentProps<typeof AlertAction>>) {
  return <AlertAction {...props} />;
}
